import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export function usePagination(items, defaultPerPage = 10) {
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(defaultPerPage);

  useEffect(() => { setPage(1); }, [items]);

  const totalPages = Math.ceil(items.length / perPage);
  const paginated = items.slice((page - 1) * perPage, page * perPage);
  const goTo = (p) => setPage(Math.max(1, Math.min(p, totalPages)));

  return {
    paginated, page, totalPages, perPage,
    setPerPage: (n) => { setPerPage(n); setPage(1); },
    goTo
  };
}

export function Pagination({ page, totalPages, goTo, perPage, setPerPage, total }) {
  const { t } = useTranslation();
  return (
    <div className="flex items-center justify-between px-12 py-4 flex-wrap gap-3 border-t border-gray-200/50">
      <div className="flex items-center gap-2 text-gray-400 text-xs">
        <span>{t('Pagination.pokazyvat')}</span>
        <select
          value={perPage}
          onChange={e => setPerPage(Number(e.target.value))}
          className="bg-gray-100 border border-gray-200 text-gray-700 text-[10px] font-black rounded-lg px-2 py-1 focus:outline-none focus:border-red-600"
        >
          {[10, 25, 50, 100].map(n => <option key={n} value={n}>{n}</option>)}
        </select>
        <span className="ml-2 text-gray-400">{t('Pagination.total_count', { total })}</span>
      </div>
      <div className="flex items-center gap-1">
        <button onClick={() => goTo(1)} disabled={page === 1}
          className="px-3 py-1.5 rounded-xl text-base leading-none font-black bg-gray-100 text-gray-500 hover:bg-red-700 hover:text-gray-900 disabled:opacity-30 transition-colors">«</button>
        <button onClick={() => goTo(page - 1)} disabled={page === 1}
          className="px-3 py-1.5 rounded-xl text-base leading-none font-black bg-gray-100 text-gray-500 hover:bg-red-700 hover:text-gray-900 disabled:opacity-30 transition-colors">‹</button>
        <span className="px-4 py-1.5 text-[10px] font-black text-gray-900 bg-white rounded-xl border border-gray-200">
          {page} / {totalPages || 1}
        </span>
        <button onClick={() => goTo(page + 1)} disabled={page === totalPages || totalPages === 0}
          className="px-3 py-1.5 rounded-xl text-base leading-none font-black bg-gray-100 text-gray-500 hover:bg-red-700 hover:text-gray-900 disabled:opacity-30 transition-colors">›</button>
        <button onClick={() => goTo(totalPages)} disabled={page === totalPages || totalPages === 0}
          className="px-3 py-1.5 rounded-xl text-base leading-none font-black bg-gray-100 text-gray-500 hover:bg-red-700 hover:text-gray-900 disabled:opacity-30 transition-colors">»</button>
      </div>
    </div>
  );
}
